import reducer from './reducers';
import * as actions from './actions';
import * as types from './types';

export default reducer;
export {
  actions,
  types,
};
